var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3594 0.336914C14.8084 -0.111983 15.5372 -0.111851 15.9863 0.336914C16.4354 0.785982 16.4353 1.51476 15.9863 1.96387L9.78809 8.16113L15.9863 14.3604C16.4351 14.8094 16.4351 15.5373 15.9863 15.9863C15.5373 16.4353 14.8095 16.4352 14.3604 15.9863L8.16113 9.78711L1.96289 15.9863C1.51377 16.4352 0.785927 16.4353 0.336914 15.9863C-0.111796 15.5373 -0.111819 14.8094 0.336914 14.3604L6.53418 8.16113L0.336914 1.96387C-0.111978 1.51475 -0.112118 0.785947 0.336914 0.336914C0.785963 -0.111922 1.51481 -0.111912 1.96387 0.336914L8.16113 6.53418L14.3594 0.336914Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon_close.2f7f0411dce78fe2476c72ae9ed32a8c.svg";
export { ForwardRef as ReactComponent };